export const DEMO_ENHANCEMENT_NOTES = {
  'board-reliability': {
    note: 'AI Studio added a stronger readiness-gating story: this demo should feel like a quality gate, not only a checklist.',
    mobile: 'Use touch-friendly sliders, readable warning cards, and clear score movement on iPhone, iPad, Android, and desktop.'
  },
  'ethernet-connectivity': {
    note: 'AI Studio emphasized workload-aware lane mapping: static lane plans should visibly contrast with adaptive fabric behavior.',
    mobile: 'Use large workload buttons and clear lane-role labels for small screens.'
  },
  'supply-chain-risk': {
    note: 'AI Studio emphasized cascade simulation: the graph should show risk movement, not just static supplier nodes.',
    mobile: 'Use large graph nodes, visible risk colors, and scroll-safe cards.'
  },
  'closed-loop-stability': {
    note: 'AI Studio emphasized drift recovery: four telemetry feeds and the event log should make correction visible.',
    mobile: 'Keep play/pause controls touch-safe and slow enough to read.'
  },
  'lithography-process-control': {
    note: 'AI Studio emphasized cross-signal correlation: overlay, CD, and defect signals should read as one combined process-window story.',
    mobile: 'Use simplified charts, readable labels, and one clear excursion trigger.'
  },
  'thermal-orchestration': {
    note: 'AI Studio emphasized heat-map comparison: naive placement versus reliability-aware routing should be visually obvious.',
    mobile: 'Keep the heat grid visible on small screens and use large mode buttons.'
  },
  'provenance-trust': {
    note: 'AI Studio emphasized trust continuity: legacy custody and quantum-safe verification should be compared clearly.',
    mobile: 'Use a clean custody timeline and large trust-state labels.'
  },
  'agent-governance': {
    note: 'AI Studio emphasized the operations-console feel: policy, evidence, review, and rollback should be visible in one view.',
    mobile: 'Make action cards readable and decision buttons thumb-friendly.'
  },
  'trigger-less-validation': {
    note: 'AI Studio emphasized waveform reconstruction: misaligned captures should become a coherent failure story.',
    mobile: 'Use simplified waveforms, clear align buttons, and short labels.'
  }
};
